import React, { useMemo } from 'react';
import styles from './DENTToothQuickAdjustmentModal.module.scss';
import { Orientation } from '../../../Base/Enums/Orientation.enum';
import { joinClasses } from '../../../../Utils/className.util';
import { useDENTContext } from '../../Services/DENTContext';
import { OverviewMode } from '../../Enums/OverviewMode.enum';
import DENTModalOverviewPeriodontal from '../DENTModalOverviewPeriodontal/DENTModalOverviewPeriodontal';
import DENTToothQuickPathologyModal from '../DENTToothQuickPathologyModal/DENTToothQuickPathologyModal';
import DENTToothQuickRestorationModal from '../DENTToothQuickRestorationModal/DENTToothQuickRestorationModal';
import DENTToothQuickCrownModal from '../DENTToothQuickCrownModal/DENTToothQuickCrownModal';
import DENTToothQuickEndodonticModal from '../DENTToothQuickEndodonticModal/DENTToothQuickEndodonticModal';

const DENTToothQuickAdjustmentModal = () => {
	const {
		activeTooth,
		overviewMode,
		quickSelectTeeth,
		setActiveTooth,
		setAdjustmentMode,
	} = useDENTContext();

	const handleCloseAdjustmentModal = () => {
		setActiveTooth(undefined);
		setAdjustmentMode(false);
	};

	const side: Orientation = useMemo(() => {
		if (activeTooth && activeTooth.number > 18 && activeTooth.number < 41)
			return Orientation.LEFT;
		return Orientation.RIGHT;
	}, [activeTooth]);

	const content = useMemo(() => {
		switch (overviewMode) {
			case OverviewMode.PERIODONTAL:
				return <DENTModalOverviewPeriodontal onClose={() => null} />;
			case OverviewMode.RESTORATION:
				return <DENTToothQuickRestorationModal />;
			case OverviewMode.PATHOLOGY:
				return <DENTToothQuickPathologyModal />;
			case OverviewMode.CROWN:
				return <DENTToothQuickCrownModal />;
			case OverviewMode.ENDODONTIC:
				return <DENTToothQuickEndodonticModal />;
			default:
				return <></>;
		}
	}, [overviewMode, activeTooth]);

	if (!(activeTooth || quickSelectTeeth.length > 0)) {
		return <></>;
	}

	return (
		<div className={joinClasses([styles.wrapper, styles[side]])}>
			<div className={styles.small}>
				<div className={styles.header}>
					{activeTooth && (
						<h2 className={styles.title}>{`Zub ${activeTooth.number}`}</h2>
					)}
					<button
						className={styles.closeButton}
						onClick={handleCloseAdjustmentModal}>
						<img src='/dist/icons/close.svg' alt='close' />
					</button>
				</div>
				<div className={styles.content}>{content}</div>
			</div>
		</div>
	);
};

export default DENTToothQuickAdjustmentModal;
